import * as yup from 'yup';

export const validationSchema = yup.object({
  candidateFirstName: yup
    .string()
    .trim()
    .required("You can't leave this blank."),
  candidateLastName: yup
    .string()
    .trim()
    .required("You can't leave this blank."),
  candidatePhone: yup.string().required("You can't leave this blank."),
  candidateEmployeeId: yup.string(),
  documentsNeeded: yup
    .array()
    .min(1, "You can't leave this blank.")
    .required("You can't leave this blank.")
    .nullable(),
});
